<template>
    <div class="  onLineAnswer beginAnswer  commonLeft">
        <div class="delFloat w-1200">
            <div class="left float-left commonShadow padding-x">
                <h3>
                    {{paperTitle}}
                </h3>
                <div class="padding-b position-relative contentPaper">
                    <div v-show="paperContentList.length>0&&!loadingContent">
                        <div :name="indexF+1" v-for="(item,indexF) in paperContentList" class="margin-medium-top" :key="indexF" >
                            <div>
                                {{indexF+1}}、
                                <span v-html="item.bodyHtml"></span>
                            </div>
                            <div>
                                <div class="margin-top questionItem text-left border  "
                                     v-show="item.optionHtmlList!==''"
                                     v-for="(itemXz,index) in item.optionHtmlList.split('|NTK|')" :key="index"
                                     :class="selectList[indexF]===index?'directoryActive':''"
                                     @click="singlePaperOption(index,indexF,item.questionId)" v-html="itemXz">
                                </div>
                            </div>
                        </div>
                    </div>
                    <empty v-show="!loadingContent&&paperContentList.length<1" :text-size="16"></empty>
                    <loading :show="loadingContent"></loading>
                </div>
            </div>
            <div class="padding-x right beginA commonShadow">
                <div class="padding-y">
                    <div style=" height:auto;" class="position-relative">
                        <div class="font-weight-bold text-m-size">
                            答题卡
                        </div>
                        <div v-show="questionTag.length>0&&!loadingContent">
                            <span class="tagNum rounded-small" :class="item.select?'selected':''"
                                  @click="selectNum(item.name)"
                                  v-for="item in questionTag"
                                  :key="item.name">
                                {{item.name}}
                            </span>
                        </div>
                        <empty v-show="questionTag.length<1&&!loadingContent" :heights="100" :widths="100" :text-size="14"></empty>
                        <loading :show="loadingContent"></loading>
                    </div>
                    <div class="margin-top" >
                        <el-button style="width:100%;" @click="entireVolumeSubmit" type="primary">
                            交 卷
                        </el-button>
                    </div>
                </div>
            </div>
        </div>
        <div></div>
    </div>
</template>

<script>
    import {testQuestionBankPaper, testQuestionBankSubmitOne} from "../../../config";
    import {message} from 'element-ui'
    export default {
        name: "onLineAnswerBegin",

        data(){
            return{
                loadingContent:false,
                paperTitle:'',
                paperContentList:[],
                paperCount:'',
                questionTag:[],
                //接收题目的选项根据此数组设置其选中
                selectList:[-1,-1,-1,-1,-1],
                //试题id
                questionId:'',
                //选项id
                optionVal:'',
                //试卷id
                paperId:'',
                //科目id
                subjectId:''
            }
        },
        mounted(){
            this.searchBankPaper();
        },
        methods:{

            //单个试题提交   当前选项的下标   题目的下标   题目的id
            singlePaperOption(optionsIndex,questionIndex,questionId){
                console.log(optionsIndex);
                console.log(questionIndex);
                // console.log(this.selectList[questionIndex]);
                this.$delete(this.selectList);
                //根据此数组判断当前选择的题是否选中
                this.selectList[questionIndex]=optionsIndex;
                this.questionTag[questionIndex].select=true;
                this.$set(this.selectList);
                // console.log(this.selectList[questionIndex]);
                let zhi='';
                switch(optionsIndex+1){
                    case 1:
                        zhi='A';
                    break;
                    case 2:
                        zhi='B';
                    break;
                    case 3:
                        zhi='C';
                    break;
                    case 4:
                        zhi='D';
                    break;
                }
                this.optionVal=zhi;
                this.questionId=questionId;
                this.singleQuestionSubmit();
            },
            //单个试题提交
            async singleQuestionSubmit(){
                let result=await testQuestionBankSubmitOne(this.questionId,this.paperId,this.optionVal);
                if(result.status){
                    console.log(result.data);
                }else{

                }
            },
            //整卷交卷
            async entireVolumeSubmit(){
                let zhi ='';
                this.questionTag.forEach((val)=>{
                    if(!val.select){
                        zhi=false;
                        return false;
                    }else{
                        zhi=true;
                    }
                    return zhi;
                })
                console.log(zhi);
                if(!zhi){
                    message({
                        message:'请作答完毕后提交',
                        type:'warning'
                    })
                }else{
                    this.$router.push({path:'/answerResult',
                        query:{paperId:this.paperId,subjectId:this.subjectId}})

                }
            },
            //根据paperId查出组卷内容
            async searchBankPaper(){
              this.paperId=this.$route.query.paperId;
              this.loadingContent=true;
              let result=await testQuestionBankPaper(this.$route.query.paperId);
              if(result.status){
                  this.subjectId=result.data.subjectId;
                  this.loadingContent=false;
                  console.log('我是组卷内容');
                  console.log(result.data);
                  this.paperTitle=result.data.paperName;
                  this.paperContentList=result.data.questions;
                  this.questionTag=[];
                  result.data.questions.forEach((valContent,index)=>{
                      this.questionTag.push({
                          name:index+1,
                          select:false
                      })
                  })
                  this.paperCount=result.data.quesCount;
              }else{
                  this.loadingContent=false;
              }
            },
            //选择顶部的专业类型
            selectNum(val){
                let zhi=document.getElementsByName(val);
                console.log(zhi);
                console.log('我是' + val+'标签所在的y轴位置');
                // window.scrollTo(0,zhi[0].offsetTop-70);
                let top=zhi[0].offsetTop+30;
                if(top<=0){
                    window.scrollTo(0,0);
                    return false;
                }
                let offsetTops=0;
                let timer=setInterval(()=>{
                    var speed = top / 5;
                    if(offsetTops>=zhi[0].offsetTop+30){
                        clearInterval(timer);
                    }else{
                        offsetTops+=speed;
                        window.scrollTo(0,offsetTops);
                    }
                },50)
            },
        }
    }
</script>

<style lang="scss"  scoped>
    .beginAnswer{
        margin-top: 10px;
        .selected{
            background: #2196f3;
            color: #ffffff;
        }
        .right.beginA{
            margin-left: 955px !important;
            position: fixed!important;
        }
        .contentPaper{
            min-height: 300px;
            height:auto;
        }
    }
</style>
